module.exports = __webpack_public_path__ + "static/img/Jack_Darling_mobile.1318813.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack_Darling_mobile.jpg
// module id = UJDD
// module chunks = 0